import ACTIONS from '@/store/storeActions';

export const confirmLogout = (dialogRef, store, router, routeTo) => {
  dialogRef(false)
  store.dispatch(ACTIONS.CLEAR_STATE, null);
  router.push(routeTo)
}

export default {}
